import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private userPermissions: string[] = [];
  private isAdmin = false;
  
  setUser(user: any) {
    this.userPermissions = Array.isArray(user?.role?.permissions) ? user.role.permissions : [];
    this.isAdmin = (user?.role?.name || '').toLowerCase() === 'admin';
  }

  hasPermission(required: string[] = []): boolean {
    return true;                       // admin always allowed
    // if (!required || required.length === 0) return true; // no specific requirement
    // return required.some(p => this.userPermissions.includes(p));
  }
}
